/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-restricted-imports  */

import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  HostListener,
  ElementRef,
  Inject,
} from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { MatSidenav } from '@angular/material/sidenav';
import {
  getAdobeSiteSection,
  MenuItem,
  Menu,
} from '@cigna/cigna-for-brokers/shared/util';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatListItem } from '@angular/material/list';
import { Subscription, Subject } from 'rxjs';
import { SubMenuNavService, Roles } from '../+state/sub-menu-nav.service';
import {
  AppStateGateway,
  GatewayConfig,
  GATEWAY_CONFIG,
} from '@cigna/cigna-for-brokers/shared/gateways';
import {
  ToolsResponse,
  AppstateFacade,
  FormattedTool,
} from '@cigna/cigna-for-brokers/shell/data-access';
import { MatDialog } from '@angular/material/dialog';
import { SelectProducerCodeComponent } from '@cigna/cigna-for-brokers/shared/ui';
import { take, takeUntil } from 'rxjs/operators';
import { ShellTrackHandlers } from '@cigna/cigna-for-brokers/shared/analytics-util';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { TranslateService } from '@ngx-translate/core';
import { TrainingEducationService } from '@cigna/cigna-for-brokers/training-education-feature';
import { get } from 'lodash';

@Component({
  selector: 'cigna-canav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.scss'],
})
export class NavItemComponent implements OnInit, OnChanges, OnDestroy {
  subMenuTrigger?: MatMenuTrigger;
  isFromSubmenu = false;
  selectedmenu = 'Dashboard';
  selectedSubMenu: string;
  subMenuClickSubscription: Subscription;
  isExpanded = false;
  apiUrl: string;
  profileData$ = this._appstateFacade.isProfileUser$;
  roles$ = this._appstateFacade.roles$;
  entitlements$ = this._appstateFacade.navigationEntitlements$;
  isCSBIncentivesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isCSBIncentivesEnabled',
  ]);
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  did0228ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'did0228ChangesEnabled',
  ]);
  did0228ChangesEnabled: boolean;

  didTraining0214ChangesEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'didTraining0214ChangesEnabled',
  ]);
  didTraining0214ChangesEnabled: boolean;

  isIfpHPSEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isIfpHPSEnabled',
  ]);
  isIfpHPSEnabled: boolean;

  isCSBIncentivesOn: boolean;
  entitlementsdata: string[];
  dataRes: string[];
  roles: Roles[] = [];
  csbRoles: Roles[] = [];
  filteredRoles: Roles[] = [];
  linkName: string;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  activeNavMenu: string | null;
  isOnDemandTrainingEducationToggleOn: boolean;
  isOnDemandTrainingEducationEnabled$ =
    this.featureTogglesFacade.featuresEnabled([
      'isOnDemandTrainingEducationEnabled',
    ]);

  isBookOfbusinessEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isBookOfbusinessEnabled',
  ]);

  isMaCompensationEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isMaCompensationEnabled',
  ]);
  isMaCompensationOn: boolean;
  isCSBCompensation: boolean;
  shouldShowUsEmpTools = false;
  envName: string;
  isNewKaplanUrlEnabledFlag: boolean;
  @Input() items: MenuItem[] = [];
  @Input() profileItems: MenuItem[] = [];
  @Input() communicationItems: MenuItem[] = [];
  @Input() goToLink: MenuItem;
  @Input() isLinkEnabled: boolean;
  @Input() source: string;
  @Input() tools: ToolsResponse;
  @Input() hasBoBMA: boolean;
  @Input() hasBoBMAInt: boolean;
  @Input() hasBoBMaApplicationStatusExt: boolean;
  @Input() hasBoBMaApplicationStatusInt: boolean;
  @Input() isImpersonatorFlag: boolean;
  @Input() hasIfpAdminMenu: boolean;
  @Input() isUsEmployerOnly: boolean;

  isBookofBusinesssEnabled: boolean;
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
  @ViewChild('usEmpToolsTrigger') usEmpToolsTrigger?: MatMenuTrigger;
  @ViewChild('usEmpToolsMenu') usEmpToolsMenu?: ElementRef;
  @Output() openExternalPage = new EventEmitter<{ source: string }>();
  @Output() redirect = new EventEmitter<{ redirect: string }>();
  @Output() navigateExternal = new EventEmitter<{
    url: string;
    target: string;
  }>();

  constructor(
    private router: Router,
    private subMenuNavService: SubMenuNavService,
    private _gw: AppStateGateway,
    public _appstateFacade: AppstateFacade,
    public dialog: MatDialog,
    private analytics: ShellTrackHandlers,
    private featureTogglesFacade: FeatureTogglesFacade,
    private translate: TranslateService,
    private trainingEducationService: TrainingEducationService,
    @Inject(GATEWAY_CONFIG) private _config: GatewayConfig,
  ) {
    router.events
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((event: Event) => {
        if (event instanceof NavigationEnd) {
          const currentUrl = event?.url;
          if (currentUrl.startsWith('/secure/medicare-medicaid-eligibility')) {
            this.setActiveNavMenu('Medicare Advantage');
            this.subMenuNavService.publishSubMenuCLicked('Tools');
          } else if (
            currentUrl.startsWith(
              '/secure/commercial/book-of-business?type=currentbusiness',
            )
          ) {
            this.setActiveNavMenu('U.S. Employer');
          }
        }
      });
  }

  @Output() goToCommercialCompStmt = new EventEmitter<{}>();
  @Output() goToSolutionsAndInsights = new EventEmitter<{}>();
  @Output() goToBookOfBusiness = new EventEmitter<{}>();
  @Output() goToSmallGroupRenewals = new EventEmitter<{}>();
  @Output() goToMaCompensationPage = new EventEmitter<{}>();
  @Output() closeMenuEmitter = new EventEmitter();
  @Output() goToCSBIncentives = new EventEmitter<{}>();
  appRedirectCa = [
    // 'New Employee Enrollment',
    // 'Banking',
    // 'Billing',
    // 'Claims',
    // 'Eligibility',
    'Claims',
    // 'Eligibility',
    // 'Fund Driven',
    'Government',
    // 'Archived',
    // 'Incentive',
  ];
  appRedirectCrp = [
    // 'New Employee Enrollment',
    'Fund Driven',
    // 'Government',
    'Utilization',
    // 'Archived',
    // 'Incentive',
    // 'Pay a Bill',
  ];

  usEmpTools: FormattedTool[] = [];

  ifpCompExternal = (entitlement: string) =>
    entitlement === 'smenu-ind-compensation-ext';

  // eslint-disable-next-line sonarjs/cognitive-complexity
  ngOnChanges() {
    if (this.isUsEmployerOnly) {
      this.usEmpTools = this.tools.contents
        .filter((tool) => tool.category === 'U.S. Employer')
        .map((tool) => ({
          text: tool.content.item['link-text'],
          icon: '',
          route: tool.content.item['link-url'],
          isExternal: tool.content.item['ext-url'],
          priority: tool.metadata.priority,
          isTool: true,
          entitlement: '',
        }))
        .sort((a, b) => parseInt(a.priority, 10) - parseInt(b.priority, 10));
    } else {
      if (this.items.length) {
        for (const item of this.items) {
          if (item.submenu) {
            const index = item.submenu?.findIndex((submenuItem) =>
              submenuItem.entitlement?.includes('-tools'),
            );
            if (index !== -1) {
              item.submenu[index].submenu = this.tools.contents
                .filter((tool) => {
                  if (item.text === 'Individual and Family') {
                    return tool.category === 'IFP';
                  }

                  if (item.text === 'Medicare Advantage') {
                    return tool.category === 'MA';
                  }
                  if (item.text === 'Cigna Supplemental') {
                    return tool.category === 'CSB';
                  }

                  if (
                    item.text === 'Commercial' ||
                    item.text === 'Commercial Plans' ||
                    item.text === 'U.S. Employer'
                  ) {
                    return tool.category === 'U.S. Employer';
                  }

                  if (item.text === 'Small Group Plans') {
                    return tool.category === 'small group';
                  }
                })
                .map((filteredTool) => ({
                  text: filteredTool.content.item['link-text'],
                  icon: '',
                  route: filteredTool.content.item['link-url'],
                  isExternal: filteredTool.content.item['ext-url'],
                  priority: filteredTool.metadata.priority,
                  isTool: true,
                  entitlement: '',
                }))
                .sort(
                  (a, b) => parseInt(a.priority, 10) - parseInt(b.priority, 10),
                );
            }
          }
        }
      }
    }
  }

  ngOnInit(): void {
    this.isCSBCompensation = this.translate.instant(`isCSBCompensation`);
    this.activeNavMenu = localStorage.getItem('activeNavMenu');
    this.selectedmenu = this.activeNavMenu ? this.activeNavMenu : 'Dashboard';
    this.roles$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((resroles) => {
      if (resroles) {
        resroles.forEach((roleitem) => {
          if (roleitem.lob === 'IFP') {
            const isRoleExist = this.roles.some(
              (role) => role.producerCode === roleitem.producerCode,
            );
            if (!isRoleExist) {
              this.roles.push(roleitem);
            }
          }
        });
      }
    });

    // role check
    this.filteredRoles = [];

    if (this.roles.length === 1) {
      this.roles.forEach((roleitem) => {
        this.filteredRoles.push(roleitem);
      });
    }

    this.entitlements$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((resentitlements) => {
        if (resentitlements) {
          this.entitlementsdata = resentitlements;
        }
      });

    this.profileData$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((res: any) => {
        if (res) {
          const obj = res.accessTokenBody['cigna.producerCodes'];
          const pcodeData = obj.split(' ');
          const ar: string[] = [];
          pcodeData.forEach((x: string) => {
            const pcode = x.split('-');
            if (pcode[0] === 'IFP') {
              ar.push(pcode[1]);
            }
          });
          this.dataRes = ar;
        }
      });

    this.isCSBIncentivesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isCSBIncentivesOn = isFeatureToggleEnabled;
      });

    this.isBookOfbusinessEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isBookofBusinesssEnabled = isFeatureToggleEnabled;
      });
    this.isMaCompensationEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isMaCompensationOn = isFeatureToggleEnabled;
      });

    this.did0228ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.did0228ChangesEnabled = isFeatureToggleEnabled;
      });

    this.didTraining0214ChangesEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.didTraining0214ChangesEnabled = isFeatureToggleEnabled;
      });

    this.isIfpHPSEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isFeatureToggleEnabled) => {
        this.isIfpHPSEnabled = isFeatureToggleEnabled;
      });

    this.appRedirectCa.push('Billing');
    this.appRedirectCa.push('Pay a Bill');
    this.appRedirectCrp.push('Pay a Bill');
    this.appRedirectCrp.push('Government');
    this.appRedirectCa.push('Incentive');
    this.appRedirectCrp.push('Incentive');

    this.setSelectedmenu();

    this.subMenuClickSubscription =
      this.subMenuNavService.subMenuClickedSubject.subscribe((subMenuItem) => {
        this.onExpandPanel(subMenuItem, false);
        this.selectedSubMenu = subMenuItem;
      });

    // this.subMenuNavService.menuClickedSubject.subscribe((isExpanded) => {
    //   this.isExpanded = isExpanded;
    // });
    this.isOnDemandTrainingEducationEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOnDemandTrainingEducationEnabled) => {
        this.isOnDemandTrainingEducationToggleOn =
          isOnDemandTrainingEducationEnabled;
      });

    this.envName = this._config.environmentName;
    const featureFlagBase = this.translate.instant(`featureFlag`);

    const flagObj = get(featureFlagBase, this.envName);
    this.isNewKaplanUrlEnabledFlag = get(flagObj, 'isNewKaplanUrlEnabled');
  }

  ngOnDestroy(): void {
    if (this.subMenuClickSubscription) {
      this.subMenuClickSubscription.unsubscribe();
    }
    this._ngUnsubscribe$.next();
    this._ngUnsubscribe$.complete();
  }

  onExpandPanel(entitlement: string, trackEvent: boolean = true) {
    const filterSubMenus = this.items.filter((x) => x.submenu);
    filterSubMenus.forEach((y) => {
      y.submenu?.forEach((z: MenuItem) => {
        if (z.entitlement === entitlement) {
          const submenu = {
            parentItem: y.text,
            item: { ...z },
            disableTracking: !trackEvent,
          };
          this.onNavItemSubMenuItemClicked(submenu);
        }
      });
    });
  }

  setSelectedmenu() {
    const activeItem = this.items.find(
      (x) => this.router.url.indexOf(x.route) !== -1,
    );
    if (activeItem) {
      this.makeActiveBrokerTemp(activeItem.text);
    }
  }

  makeActiveBrokerTemp(itemText: string) {
    this.selectedmenu = itemText;
    this.selectedSubMenu = '';
  }

  checkActiveRoute(item?: MenuItem) {
    if (this.isUsEmployerOnly) {
      if (item?.route) {
        if (
          (this.router.url.includes('/rfp') &&
            item.text === 'New Business RFPs') ||
          (this.router.url.includes('/use') && item.text === 'Dashboard') ||
          (this.router.url.includes('/commercial/marketing-materials') &&
            item.text === 'Marketing Materials')
        ) {
          return true;
        }

        let exactOrSubsetPath: 'exact' | 'subset' = 'exact';
        if (this.router.url.includes('/compensation')) {
          exactOrSubsetPath = 'subset';
        }

        return this.router.isActive(item.route, {
          paths: exactOrSubsetPath,
          queryParams: 'subset',
          fragment: 'ignored',
          matrixParams: 'ignored',
        });
      }
      return false;
    } else if (item) {
      return item.text === this.selectedmenu;
    }
  }

  checkActiveSubMenuRoute(item?: MenuItem) {
    if (!item) {
      return;
    }
    return item.text === this.selectedSubMenu;
  }

  redirectToExtUrl(extUrl: string, target: string) {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        const isOktaExtRedirectUrl = this.translate.instant(
          `global.isOktaExtRedirectUrl`,
        );
        if (isOktaLoginEnabled && isOktaExtRedirectUrl === 'true') {
          const oktaExtRedirect = this._gw.getOktaExtRedirect(extUrl);
          setTimeout(() => {
            window.open(oktaExtRedirect, target);
          }, 1500);
        } else {
          setTimeout(() => {
            window.open(extUrl, target);
          }, 1500);
        }
      });
  }

  // eslint-disable-next-line sonarjs/cognitive-complexity
  navigatePage(item?: MenuItem) {
    if (item && !this.isImpersonatorFlag) {
      if (item.entitlement === 'smenu-ind-hps-service-link') {
        if (this.isIfpHPSEnabled) {
          this.redirectToExtUrl(this._gw.getIfpHPS(), '_blank');
        }
      }
      if (item.entitlement === 'smenu-ind-sep-work-queue') {
        this.redirectToExtUrl(this._gw.getSepWorkQIntUrl(), '_blank');
      } else if (item.entitlement === 'smenu-ind-administration') {
        this.apiUrl = this._gw
          .getIfpAdminUrl()
          ?.replace('{roleId}', `${this.filteredRoles[0]?.roleId}`);
        this.apiUrl = this.apiUrl?.replace(
          '{brokerId}',
          `${this.filteredRoles[0]?.brokerId}`,
        );
        this.redirectToExtUrl(this.apiUrl, '_self');
      }
      // SGP
      else if (item.entitlement === 'smenu-sgp-compensation') {
        this.goToCompensationNavigation(item);
      }
      // Commercial
      else if (item.entitlement === 'smenu-com-compensation') {
        if (this.isUsEmployerOnly) {
          this.updateCommercialAdobe(item.text);
        }

        this.goToCompensationNavigation(item);
      } else if (item.entitlement === 'smenu-sgp-renewals') {
        this.goToSmallGroupRenewals.emit();
      } else if (item.entitlement === 'smenu-com-book-business') {
        if (this.isUsEmployerOnly) {
          this.updateCommercialAdobe(item.text);
        }

        if (this.isBookofBusinesssEnabled) {
          window.localStorage.setItem('selectedNav', 'bookOfBusiness');
          this.goToBookOfBusiness.emit();
        } else {
          this.redirectToExtUrl(this._gw.getBrokerBobCommercial(), '_self');
        }
      } else if (item.entitlement === 'smenu-com-req-proposal') {
        if (this.isUsEmployerOnly) {
          this.updateCommercialAdobe(item.text);
        }

        if (this.isBookofBusinesssEnabled) {
          window.localStorage.setItem('selectedNav', 'reqForProposal');
          this.goToBookOfBusiness.emit();
        } else {
          this.redirectToExtUrl(this._gw.getComReqProposal(), '_self');
        }
      } else if (item.entitlement === 'smenu-com-training') {
        if (item.text === 'Continuing Education') {
          if (this.isUsEmployerOnly) {
            this.updateCommercialAdobe(item.text);
          }

          if (this.isNewKaplanUrlEnabledFlag) {
            this.trainingEducationService.getContinuingEdExploreCatalogNew();
          } else {
            this.trainingEducationService.getContinuingEdExploreCatalog();
          }
        } else if (item.text === 'Plan & Product Training Hub') {
          if (this.isUsEmployerOnly) {
            this.updateCommercialAdobe(item.text);
          }

          this.trainingEducationService.getOnDemandExploreContent();
        } else {
          if (this.isOnDemandTrainingEducationToggleOn) {
            this.router.navigate([`/${item.route}`]);
          } else {
            if (item.text === 'On Demand Content') {
              this.redirectToExtUrl(this._gw.getComTraining(), '_self');
            } else if (item.text === 'Continuing Education') {
              this.redirectToExtUrl(this._gw.getComContinueEdu(), '_self');
            }
          }
        }
      } else if (item.entitlement === 'smenu-com-funding-solutions') {
        if (this.isUsEmployerOnly) {
          this.updateCommercialAdobe(item.text);
        }

        this.router.navigate(['/secure/commercial/funding']);
      } else if (item.entitlement === 'smenu-com-solutions-insights') {
        if (this.isUsEmployerOnly) {
          this.updateCommercialAdobe(item.text);
        }

        this.goToSolutionsAndInsights.emit();
      }
      // IFP
      else if (item.entitlement === 'smenu-ind-book-business') {
        this.producerCodesDialog(item.text, item);
      } else if (item.entitlement === 'smenu-ind-resource-center') {
        this.producerCodesDialog(item.text, item);
      } else if (
        item.entitlement?.includes('smenu-ind-compensation-ext') ||
        item.entitlement?.includes('smenu-ind-compensation-int')
      ) {
        this.goToCompensationNavigation(item);
      }
      // MA
      else if (item.entitlement === 'smenu-ma-quote-enroll') {
        this.redirectToExtUrl(this._gw.getBrokerQuoteAdvantage2025(), '_blank');
      } else if (
        this.hasBoBMAInt &&
        item.entitlement?.includes('smenu-ma-book-business-int')
      ) {
        this.redirectToExtUrl(this._gw.getMABOBInt(), '_blank');
      } else if (
        this.hasBoBMA &&
        item.entitlement?.includes('smenu-ma-book-business-ext')
      ) {
        this.redirectToExtUrl(this._gw.getMABOBExt(), '_blank');
      } else if (
        this.hasBoBMaApplicationStatusInt &&
        item.entitlement?.includes('smenu-ma-applic-status-int')
      ) {
        this.redirectToExtUrl(this._gw.getMAAppStatusInt(), '_blank');
      } else if (
        this.hasBoBMaApplicationStatusExt &&
        item.entitlement?.includes('smenu-ma-applic-status-ext')
      ) {
        this.redirectToExtUrl(this._gw.getMAAppStatusExt(), '_blank');
      } else if (item.entitlement === 'smenu-ma-compensation') {
        if (this.isMaCompensationOn) {
          this.goToMaCompensationPage.emit();
        } else {
          this.router.navigate([`/home`]);
        }
      } else if (item.entitlement === 'smenu-ma-request-for-info') {
        this.redirectToExtUrl(
          this._gw.getViewAllRfiUrl(this.entitlementsdata),
          '_blank',
        );
        // CSB
      } else if (item.entitlement === 'smenu-csb-quote-enroll') {
        this.redirectToExtUrl(this._gw.getQuoteEnrollOtherStates(), '_self');
      } else if (item.entitlement === 'smenu-csb-book-business') {
        this.getCsbBob();
      } else if (item.entitlement === 'smenu-csb-book-business-new') {
        this.getNewCsbBob();
      } else if (item.entitlement === 'smenu-csb-compensation') {
        this.goToCompensationNavigation(item);
      } else if (item.entitlement === 'smenu-csb-sale-marketing') {
        if (this.did0228ChangesEnabled) {
          this.redirectToExtUrl(
            this._gw.getCsbSalesMarketingMtrl_v1(),
            '_blank',
          );
        } else {
          this.redirectToExtUrl(this._gw.getCsbSalesMarketingMtrl(), '_self');
        }
      } else if (item.entitlement === 'smenu-csb-incentives') {
        this.redirectToExtUrl(this._gw.getCsbIncentives(), '_self');
      } else if (item.entitlement === 'l3menu-csb-policy-report') {
        this.redirectToExtUrl(this._gw.getCsbPolicyReporting(), '_self');
      } else if (item.entitlement === 'l3menu-csb-agent-inquiry') {
        this.redirectToExtUrl(this._gw.getCsbAgentInquiry(), '_self');
      } else if (item.entitlement === 'smenu-csb-agent-inquiry') {
        this.redirectToExtUrl(this._gw.getCsbAgentInquiry_v1(), '_self');
      } else if (item.entitlement === 'smenu-csb-policy-report') {
        this.redirectToExtUrl(this._gw.getCsbPolicyReporting_v1(), '_self');
      } else if (item.entitlement === 'smenu-csb-recruiting') {
        this.redirectToExtUrl(this._gw.getCsbRecruiting(), '_blank');
      } else if (item.entitlement === 'smenu-csb-training') {
        // this.redirectToExtUrl(this._gw.getCsbTraining(), '_blank');
        if (this.didTraining0214ChangesEnabled) {
          this.redirectToExtUrl(this._gw.getCsbTraining_v1(), '_blank');
        } else {
          this.redirectToExtUrl(this._gw.getCsbTraining(), '_blank');
        }
      } else if (item.entitlement === 'l3menu-csb-my-customers') {
        this.redirectToExtUrl(this._gw.getCsbMyCustomers(), '_self');
      } else if (item.entitlement === 'l3menu-csb-product-info') {
        this.redirectToExtUrl(this._gw.getCsbProductInfo(), '_self');
      } else if (item.entitlement === 'l3menu-csb-business-building') {
        this.redirectToExtUrl(this._gw.getCsbBusinessBuilding(), '_self');
      } else if (item.entitlement === 'l3menu-csb-benefits') {
        this.redirectToExtUrl(this._gw.getCsbBenefits(), '_self');
      } else if (item.entitlement === 'l3menu-csb-servicing-forms') {
        this.redirectToExtUrl(this._gw.getCsbServicingForms(), '_self');
      } else if (
        item.entitlement === 'smenu-csb-adam' &&
        item.text === 'Leads Dashboard'
      ) {
        this.redirectToExtUrl(this._gw.getCSBAdamLeadsDashboard(), '_self');
      } else if (
        item.entitlement === 'smenu-csb-adam' &&
        item.text === 'New Insurance Update'
      ) {
        this.redirectToExtUrl(this._gw.getCSBAdamNewInsuranceUpdate(), '_self');
      } else if (item.entitlement === 'l3menu-csb-express-app') {
        this.redirectToExtUrl(this._gw.getCsbToolsExpressApp(), '_self');
      } else if (item.entitlement === 'l3menu-csb-express-way') {
        this.redirectToExtUrl(this._gw.getCsbToolsExpressWay(), '_self');
      }
      //
      else {
        // this.selectedmenu = item.text;
        if (
          item.text === 'Prescription Drug Plan' &&
          !this.isImpersonatorFlag
        ) {
          const adobeSection = getAdobeSiteSection(this.router.url);
          this.analytics.trackEventOther({}, item.text, 'ac24437', {
            eVar119: 'MTD-1458',
            eVar120: 'left-main-nav',
            prop67: 'action',
            channel: adobeSection.channel,
            pageName: adobeSection.pageName,
            prop20: 'left-nav',
          });
        }

        if (this.router.url !== `/${item.route}` && item.route !== '') {
          this.router.navigate([`/${item.route}`]);
        }
      }
    } else if (item && this.isImpersonatorFlag) {
      if (item.entitlement === 'smenu-com-compensation') {
        this.goToCompensationNavigation(item);
      } else if (item.entitlement === 'smenu-sgp-compensation') {
        this.goToCompensationNavigation(item);
      } else if (item.entitlement === 'smenu-com-book-business') {
        if (this.isBookofBusinesssEnabled) {
          window.localStorage.setItem('selectedNav', 'bookOfBusiness');
          this.goToBookOfBusiness.emit();
        } else {
          window.open(this._gw.getBrokerBobCommercial(), '_self');
        }
      } else if (item.entitlement === 'smenu-com-req-proposal') {
        if (this.isBookofBusinesssEnabled) {
          window.localStorage.setItem('selectedNav', 'reqForProposal');
          this.goToBookOfBusiness.emit();
        } else {
          window.open(this._gw.getComReqProposal(), '_self');
        }
      } else if (item.entitlement === 'smenu-com-funding-solutions') {
        this.router.navigate(['/secure/commercial/funding']);
      } else if (item.entitlement === 'smenu-com-solutions-insights') {
        this.goToSolutionsAndInsights.emit();
      } else if (item.entitlement === 'smenu-csb-incentives') {
        window.open(this._gw.getCsbIncentives(), '_self');
      } else {
        if (this.router.url !== `/${item.route}` && item.route !== '') {
          this.router.navigate([`/${item.route}`]);
        }
      }
    }
  }

  updateCommercialAdobe(itemText: string) {
    const adobeSection = getAdobeSiteSection(this.router.url);

    this.analytics.trackEventOther({}, itemText, 'ac24437', {
      eVar119: 'MTD-4815',
      eVar120: 'left-main-nav',
      prop67: 'action',
      channel: adobeSection.channel,
      pageName: adobeSection.pageName,
      prop20: itemText,
    });
  }

  goToCompensationNavigation(item?: MenuItem) {
    if (item) {
      if (item.entitlement === 'smenu-csb-compensation') {
        if (this.isCSBCompensation) {
          this.redirectToExtUrl(this._gw.getCsbCompensation_v1(), '_self');
        } else {
          this.redirectToExtUrl(this._gw.getCsbCompensation(), '_self');
        }
      } else if (
        item.entitlement === 'smenu-com-compensation' ||
        item.entitlement === 'smenu-sgp-compensation'
      ) {
        this.goToCommercialCompStmt.emit();
      } else if (
        item.entitlement?.includes('smenu-ind-compensation-ext') ||
        item.entitlement?.includes('smenu-ind-compensation-int')
      ) {
        this.getIfpCompUrl(item.entitlement as string[], item);
      }
    }
  }

  getIfpCompUrl(entitlements: string[], item?: MenuItem) {
    const isIfpCompExt = entitlements?.some(this.ifpCompExternal);
    return isIfpCompExt
      ? this.producerCodesDialog('Compensation', item)
      : this.getIfpCompInt();
  }

  menuEnter(menuTrigger?: MatMenuTrigger, item?: MenuItem) {
    if (item) {
      this.subMenuTrigger?.closeMenu();
      if (!this.isFromSubmenu && item.submenu && item.submenu.length) {
        this.subMenuTrigger = menuTrigger;
        this.subMenuTrigger?.openMenu();
      } else {
        this.isFromSubmenu = false;
      }
    }
  }
  navigateExternalFn() {
    this.navigateExternal.emit({ url: '', target: '_blank' });
  }
  menuLeave(
    event: KeyboardEvent | MouseEvent,
    item?: MenuItem,
    navItem?: MatListItem,
  ) {
    if (
      event instanceof KeyboardEvent &&
      event.shiftKey &&
      event.key === 'Tab'
    ) {
      this.subMenuTrigger?.closeMenu();
      this.isFromSubmenu = true;
    }
    if (
      event instanceof MouseEvent &&
      item?.submenu?.length &&
      this.subMenuTrigger?.menuOpen &&
      navItem &&
      (event.clientY >= navItem._hostElement.getBoundingClientRect().bottom ||
        event.clientY <= navItem._hostElement.getBoundingClientRect().top)
    ) {
      this.subMenuTrigger.closeMenu();
    }
  }

  onNavItemSubMenuItemClicked(event: {
    item: MenuItem;
    parentItem: string;
    disableTracking: boolean;
  }) {
    if (!event.disableTracking && !this.isImpersonatorFlag) {
      const adobeSection = getAdobeSiteSection(this.router.url);
      this.analytics.trackEventOther({}, event.item.text, 'ac24437', {
        eVar119: 'MTD-1458',
        eVar120: 'left-main-nav',
        prop67: 'action',
        channel: adobeSection.channel,
        pageName: adobeSection.pageName,
        prop20: event.parentItem,
      });
    }

    this.selectedSubMenu = event.item.text;
    this.setActiveNavMenu(event?.parentItem);
    this.makeActiveBrokerTemp(event.parentItem);
    this.navigatePage(event.item);
    this.closeMenuEmitter.emit();
  }

  onMatExpanded(itemText: string, parentItemsIndex: number) {
    this.items.forEach((x, i) => {
      x.open = i === parentItemsIndex;
    });
    this.selectedmenu = itemText;
    this.removeActiveNavMenu(itemText);
  }

  setIsExpanded(itemTxt: string): boolean {
    return this.selectedmenu === itemTxt;
  }

  subMenuItemClicked(item: MenuItem) {
    if (
      item.text !== 'Plan & Product Training Hub' &&
      item.text !== 'Continuing Education'
    ) {
      this.setActiveNavMenu(item?.text);
      this.makeActiveBrokerTemp(item.text);
    }

    this.items.forEach((x, i) => {
      x.open = false;
    });

    this.navigatePage(item);
  }

  setActiveNavMenu(navMenuText: string) {
    this.selectedmenu = navMenuText;
    this.activeNavMenu = navMenuText;
    localStorage.setItem('activeNavMenu', navMenuText);
  }

  removeActiveNavMenu(navMenuText: string) {
    this.activeNavMenu = navMenuText;
    localStorage.removeItem('activeNavMenu');
  }

  producerCodesDialog(itemText: string, item?: MenuItem): void {
    if (itemText === 'Book of Business') {
      this.linkName = 'broker.bookOfBusiness.plans';
    } else if (itemText === 'Compensation') {
      this.linkName = 'broker.ifp.compensation';
    } else if (itemText === 'Resource Center') {
      this.linkName = 'broker.ifp.rc';
    }

    // role check
    this.filteredRoles = [];
    if (Array.isArray(item?.entitlement)) {
      item?.entitlement?.forEach((ent) => {
        this.roles.forEach((roleitem) => {
          const isExist = roleitem.entitlements?.some(
            (check: string) => check === ent,
          );
          if (isExist) {
            const isRoleExist = this.filteredRoles.some(
              (role) => role.producerCode === roleitem.producerCode,
            );
            if (!isRoleExist) {
              this.filteredRoles.push(roleitem);
            }
          }
        });
      });
    } else {
      this.roles.forEach((roleitem) => {
        const isExist = roleitem.entitlements?.some(
          (check: string) => check === item?.entitlement,
        );
        if (isExist) {
          const isRoleExist = this.filteredRoles.some(
            (role) => role.producerCode === roleitem.producerCode,
          );
          if (!isRoleExist) {
            this.filteredRoles.push(roleitem);
          }
        }
      });
    }

    if (this.filteredRoles.length === 1) {
      if (
        (this.linkName === 'broker.bookOfBusiness.plans' ||
          this.linkName === 'broker.ifp.compensation') &&
        !this.filteredRoles[0].isContractValid
      ) {
        this.dialog.open(SelectProducerCodeComponent, {
          width: '710px',
          data: {
            urllink: this.linkName,
            data: this.dataRes,
            rolesdata: this.filteredRoles,
            navdata: '',
            hasIfpAdminMenuFlag: this.hasIfpAdminMenu,
          },
          autoFocus: false,
        });
      } else {
        this.goToURL(this.linkName);
      }
    } else if (this.filteredRoles.length >= 1) {
      this.dialog.open(SelectProducerCodeComponent, {
        width: '710px',
        data: {
          urllink: this.linkName,
          data: this.dataRes,
          rolesdata: this.filteredRoles,
          hasIfpAdminMenuFlag: this.hasIfpAdminMenu,
        },
        autoFocus: false,
      });
    }
  }

  goToURL(urlLinkName: string): void {
    if (urlLinkName === 'broker.ifp.compensation') {
      this.getIfpCompExt(
        this.filteredRoles[0]?.roleId,
        this.filteredRoles[0]?.brokerId,
      );
    } else if (urlLinkName === 'broker.ifp.rc') {
      this.getIfpResourceCenterExt(
        this.filteredRoles[0]?.roleId,
        this.filteredRoles[0]?.brokerId,
      );
    } else if (urlLinkName === 'broker.bookOfBusiness.plans') {
      this.getBrokerBobPlans(
        this.filteredRoles[0]?.roleId,
        this.filteredRoles[0]?.brokerId,
      );
    }
  }

  getCsbBob() {
    if (!this.isImpersonatorFlag) {
      this.apiUrl = this._gw.getCsbBob();
      this.redirectToExtUrl(this.apiUrl, '_self');
    }
  }
  getNewCsbBob() {
    if (!this.isImpersonatorFlag) {
      this.apiUrl = this._gw.getNewCsbBob();
      this.redirectToExtUrl(this.apiUrl, '_self');
    }
  }

  getBrokerBobPlans(roleId: string, brokerId: string) {
    if (!this.isImpersonatorFlag) {
      this.apiUrl = this._gw
        .getBrokerBobPlans()
        ?.replace('{roleId}', `${roleId}`);

      this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
      this.redirectToExtUrl(this.apiUrl, '_self');
    }
  }

  getIfpCompExt(roleId: string, brokerId: string) {
    this.apiUrl = this._gw.getIfpCompExt()?.replace('{roleId}', `${roleId}`);

    this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
    this.redirectToExtUrl(this.apiUrl, '_self');
  }

  getIfpCompInt() {
    this.apiUrl = this._gw.getIfpCompInt();
    this.redirectToExtUrl(this.apiUrl, '_self');
  }

  getIfpResourceCenterExt(roleId: string, brokerId: string) {
    if (!this.isImpersonatorFlag) {
      this.apiUrl = this._gw
        .getIfpResourceCenterExt()
        ?.replace('{roleId}', `${roleId}`);

      this.apiUrl = this.apiUrl?.replace('{brokerId}', `${brokerId}`);
      this.redirectToExtUrl(this.apiUrl, '_self');
    }
  }

  getMyMessages() {
    if (!this.isImpersonatorFlag) {
      const adobeSection = getAdobeSiteSection(this.router.url);
      this.analytics.trackEventOther({}, 'My Messages', 'ac24432', {
        eVar119: 'MTD-1446',
        eVar120: 'my-messages-link',
        prop67: 'action',
        channel: adobeSection.channel,
        pageName: adobeSection.pageName,
        prop20: 'left-nav',
      });
    }
  }

  usEmpToolsClicked($event: MouseEvent) {
    if (this.usEmpToolsTrigger?.menuOpen) {
      this.usEmpToolsTrigger.closeMenu();
    } else {
      if (this.isUsEmployerOnly) {
        this.updateCommercialAdobe('Tools');
      }

      this.usEmpToolsTrigger?.openMenu();
      $event.stopPropagation();
    }
  }

  usEmpToolItemClicked(itemText: string, url: string) {
    if (!this.isImpersonatorFlag) {
      const adobeSection = getAdobeSiteSection(this.router.url);
      this.analytics.trackEventOther({}, itemText, 'ac24431', {
        eVar119: 'MTD-4815',
        eVar120: 'tools-links',
        prop67: 'action',
        channel: adobeSection.channel,
        pageName: adobeSection.pageName,
        prop20: 'tools',
        prop51: 'U.S.Commercial',
      });
    }

    window.open(url, '_blank');
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.usEmpToolsTrigger?.menuOpen &&
      this.usEmpToolsMenu?.nativeElement &&
      !this.usEmpToolsMenu.nativeElement.contains(event.target as Node)
    ) {
      this.usEmpToolsTrigger.closeMenu();
    }
  }
}
